import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  row: {
    borderBottom: `1px solid ${theme.palette.divider} !important`,
    boxSizing: 'border-box',
    height: '50px',
    backgroundColor: theme.palette.primary.contrastText,
    transition: ' background-color 0.2s',
    '&:hover': {
      backgroundColor: `${theme.palette.background.default} !important`,
      '& $blue-hover': {
        color: theme.palette.info.main,
      },
      '& $hover-only': {
        opacity: 1,
      },
    },
    '&:last-child': {
      borderBottom: 'none !important',
    },
    [theme.breakpoints.down('md')]: {
      display: 'block',
      padding: '20px',
      height: '100%',
      position: 'relative',
    },
  },
  cell: {
    padding: '4px',
    boxSizing: 'border-box',

    '& $small': {
      fontSize: '14px',
      color: theme.palette.text.primary,
    },

    '& $small-light': {
      fontSize: '14px',
      color: theme.palette.text.secondary,
    },

    '& $date': {
      fontSize: '14px',
      color: theme.palette.text.secondary,
      textAlign: 'left',

      [theme.breakpoints.down('md')]: {
        position: 'absolute',
        top: '10px',
        right: '10px',
        fontSize: '12px',
        textAlign: 'right',
      },
    },

    '& $status': {
      '& > div': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        [theme.breakpoints.down('md')]: {
          display: 'block',
        },
      },

      [theme.breakpoints.down('md')]: {
        position: 'absolute',
        top: 'calc(50% - 4px)',
        left: 0,
      },
    },

    '& $default': {
      fontSize: '16px',
      [theme.breakpoints.down('md')]: {
        paddingBottom: '5px',
      },
    },

    '& $blue-hover': {
      fontSize: '16px',
    },

    '& $hover-only': {
      opacity: 0,
      transition: 'opacity 0.2s',
    },

    [theme.breakpoints.down('md')]: {
      display: 'block',
      width: '100%',
      height: '100%',
      padding: '0px 0px 0px 10px',
    },
  },
  small: {
    fontSize: '14px',
    color: theme.palette.text.primary,
  },
  'small-light': {
    fontSize: '14px',
    color: theme.palette.text.secondary,
  },
  date: {
    fontSize: '14px',
    color: theme.palette.text.secondary,
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      position: 'absolute',
      top: '10px',
      right: '10px',
      fontSize: '12px',
      textAlign: 'right',
    },
  },
  status: {
    '& > div': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        display: 'block',
      },
    },
    [theme.breakpoints.down('md')]: {
      position: 'absolute',
      top: 'calc(50% - 4px)',
      left: 0,
    },
  },
  default: {
    fontSize: '16px',
  },
  'blue-hover': {
    fontSize: '16px',
    '&:hover': {
      color: theme.palette.info.main,
    },
  },
  'hover-only': {
    opacity: 0,
    transition: 'opacity 0.2s',
    '&:hover': {
      opacity: 1,
    },
  },
}));
